import { useEffect, useRef, useState } from "react";
import "./dashboard.styles.scss";

// images
import AppleStore from "../../images/apple-store.png";
import GooglePlayStore from "../../images/google-playstore.png";

//icons
import { IoChatbubblesOutline, IoPlayCircleOutline } from "react-icons/io5";
import { SiJitsi } from "react-icons/si";

//components
import axios from "axios";
import Pusher from "react-pusher";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import MainContainer from "../../components/main-container/main-container.component";
import MeetingTable from "../../components/meeting-table/MeetingTable";
import clientConfig from "../../env";
import { updateBetaCredit } from "../../redux/user/user.actions";
import CountdownTimer from "../../components/CountdownTimer";
import Events from "../../components/Events/Events";
import Attendees from "../../components/Events/Attendees";

const Dashboard = ({ props }) => {
  const meetingTableRef = useRef(null);
  const joinTableConfirmationRef = useRef(null);
  const joinTableConfirmationClosebtnRef = useRef(null);
  const [popupVisible, setPopupVisible] = useState(false);

  const [popupJoinTableNumber, setPopupJoinTableNumber] = useState(null);

  const firstname = useSelector((state) => state.user.firstName);
  const userCredit = useSelector((state) => state.user.mycredits);
  const status = useSelector((state) => state.user.status);
  const userId = useSelector((state) => state.user.userId);
  const token = useSelector((state) => state.user.token);
  const email_verified = useSelector((state) => state.user.email_verified);

  const currentEventDetail = useSelector(
    (state) => state.events.currentEventDetail
  );

  const isAllTableDisable = useSelector(
    (state) => state.events.allTableDisable
  );

  const isMasterTableEnable = useSelector(
    (state) => state.events.masterTableEnable
  );

  // TODO: new code 23/05/2025
  const [tableList, setTableList] = useState([]);
  const [eventTableUsers, setEventTableUsers] = useState([]);
  const [isLoadingTableList, setLoadingTableList] = useState(true);
  // TODO: new code 23/05/2025 End

  const dispatch = useDispatch();

  const callSchedulefromParent = () => {
    setPopupVisible(!popupVisible);
  };

  const handleJoinTableConfirmation = (data, event) => {
    console.log(event.target.alt);
    console.log(data);
    if (event.target.alt.indexOf("Table") === -1) return;
    if (data?.room_limit === data?.user_count) {
      toast.error("Room limit reached");
    } else {
      const userList = data?.user_list;
      const userFound =
        userList?.length && userList?.find((u) => u.id === userId);

      if (userFound) {
        toast.error("You already joined the table");
        return;
      }

      setPopupJoinTableNumber(data?.room_slug);
      joinTableConfirmationRef.current.click();
    }
  };

  const handleCloseTableConfirmation = () => {
    joinTableConfirmationClosebtnRef.current.click();
  };

  const handleJoinTable = () => {
    meetingTableRef.current.updateUserCreditDetails(popupJoinTableNumber);
  };

  // const handleJoinTable = (tableId) => {
  //   if (userCredit) {
  //     const headers = {
  //       "Content-Type": "application/json",
  //       Authorization: `Barer ${token}`,
  //     };

  //     let updatedCredit = userCredit - 10;

  //     const data = {
  //       my_credits: updatedCredit,
  //     };

  //     axios
  //       .post(`${clientConfig.siteUrl}wl/v1/user/${userId}`, data, {
  //         headers: headers,
  //       })
  //       .then((response) => {
  //         if (response.status === 200) {
  //           console.log({ updatedCredit });
  //           console.log(response);
  //           document.getElementById("jointableClosebtn").click();
  //           window.open(
  //             `https://video.3for3networking.com/${tableId}`,
  //             "_blank"
  //           );
  //         }
  //       })
  //       .then(() => {
  //         dispatch(updateMyCredit(updatedCredit));
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //       });
  //   }
  // };

  // TODO: new code 23/05/2025
  function distributeUsersIntoGroups(users, roomLimit) {
    const numberOfGroups = 4;
    let distribution = [];

    if (roomLimit === 4) {
      distribution = [1, 1, 1, 1]; // Each group gets 1 user
    } else if (roomLimit === 6) {
      distribution = [2, 1, 2, 1]; // Groups 1 and 3 get 2 users, others get 1
    } else if (roomLimit === 8) {
      distribution = [3, 1, 3, 1]; // Groups 1 and 3 get 3 users, others get 1
    } else {
      const baseUsersPerGroup = Math.floor(roomLimit / numberOfGroups);
      const remainder = roomLimit % numberOfGroups;

      distribution = Array(numberOfGroups).fill(baseUsersPerGroup);

      for (let i = 0; i < remainder; i++) {
        distribution[i % 2 === 0 ? 0 : 2]++;
      }
    }

    const groups = [];
    let userIndex = 0;

    for (let groupIndex = 0; groupIndex < numberOfGroups; groupIndex++) {
      const userCount = distribution[groupIndex];
      const groupUsers = [];

      for (let i = 0; i < userCount && userIndex < users.length; i++) {
        groupUsers.push(users[userIndex]);
        userIndex++;
      }

      groups.push(groupUsers);
    }

    return groups;
  }

  const tableOrUserList = async (roomID) => {
    const configheader = {
      "Content-Type": `application/json`,
    };
    try {
      const response = await axios.get(
        `${clientConfig.siteUrl}wl/v1/rooms-users`,
        { headers: configheader }
      );

      const eventTableUsers = [];
      const otherTableUsers = [];
      response?.data?.forEach((table) => {
        const users = table?.users || [];
        if (table?.room_slug === "event_table") {
          eventTableUsers.push({
            id: table?.id,
            room_title: table?.room_title,
            room_slug: table?.room_slug,
            room_limit: table?.room_limit,
            user_count: users?.length || 0,
            user_list: users || [],
            users: distributeUsersIntoGroups(users, table?.room_limit) || [],
          });
        } else {
          otherTableUsers.push({
            id: table?.id,
            room_title: table?.room_title,
            room_slug: table?.room_slug,
            room_limit: table?.room_limit,
            user_count: users?.length || 0,
            user_list: users || [],
            users: distributeUsersIntoGroups(users, table?.room_limit) || [],
          });
        }
      });
      setTableList(otherTableUsers);
      setEventTableUsers(eventTableUsers);

      console.log({ eventTableUsers });

      // const tables = response?.data?.map((table) => {
      //   const users = table?.users || [];

      //   return {
      //     id: table?.id,
      //     room_title: table?.room_title,
      //     room_slug: table?.room_slug,
      //     room_limit: table?.room_limit,
      //     user_count: users?.length || 0,
      //     user_list: users || [],
      //     users: distributeUsersIntoGroups(users, table?.room_limit) || [],
      //   };
      // });
      // setTableList(tables);
      setLoadingTableList(false);
      // return tables;
      return otherTableUsers;
    } catch (e) {
      toast.error(
        e?.response?.data?.message ||
          "Something went wrong. Please try again later."
      );
      setLoadingTableList(false);
      return [];
    }
  };

  const getEventData = async () => {
    const headers = {
      "Content-Type": `application/json`,
    };
    try {
      const response = await axios.get(
        `${clientConfig.siteUrl}wl/v1/get-event`,
        { headers: headers }
      );

      if (response.status === 200) {
        if (response.data.type === "success") {
          const details = JSON.parse(response.data.result);
          // setEventDetails(details);
          console.log({ details });
          if (details) {
            dispatch({
              type: "GET_CURRENT_WEEK_EVENT",
              payload: details,
            });
          }
        } else {
          toast.error(response.data.message);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    tableOrUserList();
    // getEventData();
  }, []);
  // TODO: new code 23/05/2025 End

  // TODO: need to add Plan logic as well
  const handleAdd20CreditBeta = async () => {
    if (parseInt(userCredit) > 100) {
      toast.warning("Max credits reached for current plan.");
      return;
    }

    try {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Barer ${token}`,
      };
      const response = await axios.post(
        `${clientConfig.siteUrl}wl/v1/add-beta-credits`,
        {
          credit: 20,
          user_id: userId,
        },
        {
          headers,
        }
      );

      if (response.status === 200) {
        dispatch(updateBetaCredit(20));
        toast.success(response.data.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <MainContainer
        callSchedulefromParent={callSchedulefromParent}
        popupVisible={popupVisible}
      >
        {/* { popupVisible && <UserProfilePopup profile={profileData} popupVisible={popupVisible} sendDatatoParent={sendDatatoParent} NextProfileClickToParent={NextProfileClickToParent} loading={profileDataLoaded}/>} */}

        <div className="dashboard-container px-0 py-3 mx-0 mx-md-3 my-3 my-md-4 align-items-center justify-content-center">
          <div className="">
            <h1 className="title">Welcome, {firstname}.</h1>
            <div className="welcome-subtitle">Let's Get You Connecting!</div>

            <button
              className={`btn btn-primary px-5 py-2 rounded-10 mt-3 schedule_btn_circle ${
                (!!!userCredit || email_verified === null) && "disabled"
              }`}
              onClick={callSchedulefromParent}
              disabled={
                !!!userCredit || email_verified === null
                  ? true
                  : false || status === "Inactive"
              }
            >
              Schedule a Call
            </button>

            <ul className="list-group list-group-horizontal justify-content-center mt-3">
              <li className="list-group-item pr-2 pl-0 py-0 border-0 font-weight-bold">
                Learn Something.
              </li>
              <li className="list-group-item px-2 py-0 border-0 font-weight-bold">
                Teach Something.
              </li>
              <li className="list-group-item px-2 py-0 border-0 font-weight-bold">
                Help Someone.
              </li>
            </ul>

            <div className="border-0 my-0 py-4">
              <h5
                className="howitworks-title px-4 py-2 rounded-10"
                data-toggle="modal"
                data-target="#howitworksmodal"
              >
                <span className="phone-icon">
                  <IoPlayCircleOutline size="2.8em" color="black" />
                </span>{" "}
                Welcome Intro
              </h5>
            </div>

            <h5
              className="questions-title px-4 py-2 rounded-10"
              data-toggle="modal"
              data-target="#questionsmodal"
            >
              <span className="chat-icon">
                <IoChatbubblesOutline size="1.4em" color="red" />
              </span>{" "}
              The Questions
            </h5>
          </div>

          <>
            <div className="row my-5">
              <div className="col-12">
                <CountdownTimer />
                {currentEventDetail && <Attendees userId={userId} />}
              </div>
            </div>

            <Events />

            <div className="row mt-5">
              <div className="col-12">
                {isMasterTableEnable ? (
                  <div className="mb-4">
                    <h2 className="title">The Table</h2>

                    <button
                      type="button"
                      className="btn btn-primary rounded-10 mt-2 px-5"
                      onClick={() =>
                        meetingTableRef.current.handleJoinTable("event_table")
                      }
                    >
                      Join the Table
                    </button>

                    <div className="table-users-list mt-2">
                      {eventTableUsers[0]?.user_list?.length > 0 && (
                        <div className="d-flex align-items-center flex-column align-content-center w-100 mb-3">
                          <div className="d-flex">
                            {eventTableUsers[0]?.user_list.map(
                              (person, index) =>
                                index < 5 && (
                                  <img
                                    key={index}
                                    src={person.avatar}
                                    alt={person.name}
                                    className="rounded-circle border border-dark bg-secondary"
                                    style={{
                                      width: "50px",
                                      height: "50px",
                                      objectFit: "cover",
                                      marginLeft: index === 0 ? "0" : "-20px",
                                      zIndex: 10 + index,
                                    }}
                                  />
                                )
                            )}
                            
                            {eventTableUsers[0]?.user_list.length > 5 ? (
                              <div
                                className="rounded-circle text-white d-flex justify-content-center align-items-center border border-dark"
                                style={{
                                  width: "50px",
                                  height: "50px",
                                  marginLeft: "-20px",
                                  fontSize: "18px",
                                  zIndex: 15,
                                  background: "#3762b4",
                                }}
                              >
                                {eventTableUsers[0]?.user_list.length - 5}+
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  <h2 className="title">Join the Table</h2>
                )}
                {!email_verified ? (
                  <div className="welcome-subtitle mb-0 text-danger">
                    Verify your email to join.
                  </div>
                ) : (
                  <>
                    <div className="welcome-subtitle mb-0">
                      <strong>10 credits</strong> to join.
                    </div>
                    <p className="mt-1 mb-0">
                      <span
                        className="btn p-0 btn-link"
                        onClick={handleAdd20CreditBeta}
                      >
                        Welcome to the beta. Get 20 free credits.
                      </span>
                    </p>
                  </>
                )}
              </div>

              {isLoadingTableList ? (
                <div className="col-12 text-center">Loading...</div>
              ) : (
                <>
                  {!isLoadingTableList && (
                    <Pusher
                      channel="meeting"
                      event="meeting_updates"
                      onUpdate={tableOrUserList}
                    />
                  )}

                  {tableList.map((table, tableIndex) => (
                    <MeetingTable
                      key={tableIndex}
                      tableIndex={tableIndex}
                      data={table}
                      isLoading={isLoadingTableList}
                      ref={meetingTableRef}
                      handleJoinTableConfirmation={handleJoinTableConfirmation}
                      handleCloseTableConfirmation={
                        handleCloseTableConfirmation
                      }
                      tableDisable={isAllTableDisable}
                    />
                  ))}
                </>
              )}
            </div>

            <div className="row mt-5" id="app_download_sec">
              <div className="col-12 col-lg-6 mx-auto">
                <p>
                  <SiJitsi fontSize={"3em"} />
                </p>
                <p className="font-weight-bold" id="info">
                  We use Jitsi for the ultimate web chat experience. Download
                  the app.
                </p>

                <div className="row justify-content-center" id="logos">
                  <div className="col-12 col-sm-6 col-md-4 col-lg-6 my-2 text-lg-right">
                    <a
                      href="https://apps.apple.com/us/app/jitsi-meet/id1165103905"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        src={AppleStore}
                        alt="Apple store"
                        className="img-fluid"
                      />
                    </a>
                  </div>
                  <div className="col-12 col-sm-6 col-md-4 col-lg-6 my-2 text-lg-left">
                    <a
                      href="https://play.google.com/store/apps/details?id=org.jitsi.meet&pli=1"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        src={GooglePlayStore}
                        alt="Google play store"
                        className="img-fluid"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="modal fade"
              id="jointablemodal"
              tabIndex="-1"
              aria-labelledby="jointablemodalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="jointablemodalLabel">
                      Join the Table
                    </h5>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                      ref={joinTableConfirmationClosebtnRef}
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <button
                      hidden={true}
                      ref={joinTableConfirmationRef}
                      data-toggle="modal"
                      data-target="#jointablemodal"
                    ></button>
                  </div>
                  <div className="modal-body">
                    <p className="m-0 text-left">
                      Confirm to join the table. <strong>10 credits</strong> to
                      join.
                    </p>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-primary rounded-10"
                      onClick={handleJoinTable}
                    >
                      Confirm
                    </button>
                    <button
                      id="jointableClosebtn"
                      type="button"
                      className="btn btn-secondary rounded-10"
                      data-dismiss="modal"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>

          <div
            className="modal fade"
            id="howitworksmodal"
            tabIndex="-1"
            aria-labelledby="howitworksLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered modal-xl">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="howitworksLabel">
                    Welcome Intro
                  </h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="embed-responsive embed-responsive-16by9">
                          <iframe
                            src="https://www.youtube.com/embed/iixoh1c-MUA?controls=0"
                            title="Welcome to 3for3 Networking"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowFullScreen
                          ></iframe>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <ul className="howitworks-list">
                          <li>Schedule a time that is convenient for you.</li>
                          <li>Engage on the call.</li>
                          <li>Build your network with new connections.</li>
                        </ul>

                        <p className="text-uppercase m-0 text-left">
                          It all starts with one 15 minute introductory call.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="modal fade"
            id="questionsmodal"
            tabIndex="-1"
            aria-labelledby="questionsLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered modal-xl">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="questionsLabel">
                    The Questions
                  </h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-md-6 mb-5 mb-xl-0">
                        <div className="embed-responsive embed-responsive-16by9">
                          <iframe
                            src="https://www.youtube.com/embed/y3GRMQZvtjU?controls=0"
                            title="The Questions"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowFullScreen
                          ></iframe>
                        </div>
                      </div>
                      <div className="col-md-6 text-left">
                        <p className="questions-subtitle">
                          These are mererly icebreaker questions for your first
                          call but they are also some of the most powerful
                          conversation questions for business.
                        </p>

                        <p>What is your story? Tell me about your work.</p>

                        <p>What is something not everyone knows about you?</p>

                        <p>How can I help you?</p>

                        <p className="text-uppercase mb-4">
                          Bringing <strong>Real</strong> people together for{" "}
                          <strong>Real</strong> conversations.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </MainContainer>
    </>
  );
};

// const mapStateToProps = state => ({
//     myCredits : state.user.mycredits,
//     status: state.user.status
// })

// const mapDispatchToProps = dispatch => ({
//     //setMyCredit: () => dispatch(setMyCredit())
// })

// export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
export default Dashboard;
